var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-page',{attrs:{"page-title":"Bank Accounts","page-icon":"mdi-folder-outline","collection-name":"bank","items-per-page":20,"add-dialog-title":"Add Bank Account","is-filter":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }